import { NgModule } from '@angular/core';

import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RestoreComponent } from './restore/restore.component';
import { ChangeComponent } from './change/change.component'
import { EmailComponent } from './email/email.component';
import { CloudsignerfailedComponent } from '../handler/cloudsignerfailed/cloudsignerfailed.component';
import { CloudsignersuccessComponent } from '../handler/cloudsignersuccess/cloudsignersuccess.component';
import { TransbanksuccessComponent } from '../handler/transbanksuccess/transbanksuccess.component';
import { PreRegisterComponent } from './preregister/preregister.component';
import { EcertsuccessComponent } from '../handler/ecertsuccess/ecertsuccess.component';
const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'registrar/:guid', component: RegisterComponent },
    { path: 'preregistrar', component: PreRegisterComponent },
    { path: 'solicitar', component: RestoreComponent },
    { path: 'change/:id', component: ChangeComponent },
    { path: 'email', component: EmailComponent },
    { path: 'firmafailes/:id', component: CloudsignerfailedComponent },
    { path: 'firmasuccess', component: CloudsignersuccessComponent },
    { path: 'ts/:id', component: TransbanksuccessComponent },
    { path: 'firmaEcert/:id', component: EcertsuccessComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
